export default __webpack_public_path__ + "static/media/flag-saint-barthelemy.127b5e3b.svg";